module.exports = __webpack_public_path__ + "img/no-notification.43716e3f.svg";